import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '../views/Login/login.vue'
import Navbar from '../views/Navbar/Navbar.vue'
import Inicio from '../views/Inicio/Inicio.vue'
import Administracion from '../views/Rutas/Administrador.vue'
import Cliente from '../views/Rutas/Cliente.vue'
import RegistarNuevo from '../views/Rutas/ClienteNuevo.vue'
import NuevaConfiguracion from '../views/Configuracion/configuracion.vue'
import NuevoAcceso from '../views/Accesos/ConfiguracionAcceso.vue'
import Usuarios from '../views/CreacionUsuario/Usuario.vue'
import Reportes from '../views/Reporte/ReporteBI.vue'
import NoEncontrado from '../views/Errores/NoEncontrado.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Login',
    component: Login,
    meta: { title: 'Iniciar sesión' },
  },
  {
    path: '/Home',
    alias: '/dashboard',
    component: Navbar,
    meta: { autenticado: true },
    children: [
      { path: '', name: 'inicio', component: Inicio, meta: { title: 'Inicio' } },
      { path: 'administrador', name: 'REGISTRAR LINK BI', component: Administracion, meta: { title: 'Administrar Power BI' } },
      { path: 'cliente/:idCategoria', name: 'DASHBOARD', component: Cliente, meta: { title: 'Dashboard' } },
      { path: 'configuracion', name: 'configuracion', component: NuevaConfiguracion, meta: { title: 'Configuración' } },
      { path: 'accesos', name: 'accesos', component: NuevoAcceso, meta: { title: 'Perfiles y accesos' } },
      { path: 'registrar', name: 'registro', component: RegistarNuevo, meta: { title: 'Seleccionar cliente' } },
      { path: 'usuarios', name: 'Usuarios', component: Usuarios, meta: { title: 'Usuarios' } },
      { path: 'reportes', name: 'Reportes', component: Reportes, meta: { title: 'Reportes' } },
    ],
  },
  { path: '/administrador', redirect: '/Home/administrador' },
  { path: '/cliente/:idCategoria', redirect: to => `/Home/cliente/${to.params.idCategoria}` },
  { path: '/configuracion', redirect: '/Home/configuracion' },
  { path: '/accesos', redirect: '/Home/accesos' },
  { path: '/registrar', redirect: '/Home/registrar' },
  { path: '/usuarios', redirect: '/Home/usuarios' },
  { path: '/reportes', redirect: '/Home/reportes' },
  { path: '*', name: 'NoEncontrado', component: NoEncontrado, meta: { title: 'Página no encontrada' } },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
})

router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('access_token')
  const requiereAutenticacion = to.matched.some(record => record.meta.autenticado)

  if (requiereAutenticacion && !token) {
    next({ path: '/', query: { redirect: to.fullPath } })
    return
  }

  if (to.name === 'Login' && token) {
    next('/Home')
    return
  }

  next()
})

router.afterEach(to => {
  document.title = `${to.meta.title || 'Qhatu'} | Qhatu`
})

export default router
